(function (ws) {
    'use strict';
    ws.views.nonPhysicalProductsTable = ws.views.staticTable.extend({

        /**
         * Google Analytics Variables
         */
        GTM_EVENT_CATEGORY: 'order_activity',
        GTM_EVENT_ACTION_CARRIER_TRACKING: 'carrier tracking',
        GTM_EVENT_ACTION_INVOICE_LINK: 'invoice pdf',
        GTM_EVENT_ACTION_INFORMATION_ICON: 'information tooltip',
        GTM_EVENT_ACTION_PACKING_SLIP: 'packing_slip',
        GTM_EVENT_ACTION_PACKING_SLIP_LABEL: 'order_detail_click_packing_slip_number',

        /**
         * initialize override
         */
        initialize: function() {
            this.$table = this.$('#non-physical-products-table');
            this.$hideColumn = $.trim(this.$('.ppt-hide-column').html());

            this.responsivePriority = [
                { responsivePriority: 1 },
                { responsivePriority: 1 },
                { responsivePriority: 1 },
                { responsivePriority: 1 },
                { responsivePriority: 1 },
                { responsivePriority: 1 },
                { responsivePriority: 2 },
                { responsivePriority: 2 },
                { responsivePriority: 2 },
                { responsivePriority: 2 },
                { responsivePriority: 2 },
                { responsivePriority: 2 },
                { responsivePriority: 3 },
                { responsivePriority: 3 },
                { responsivePriority: 3 },
                { responsivePriority: 3 },
                { responsivePriority: 4 },
                { responsivePriority: 4 },
                { responsivePriority: 4 },
                { responsivePriority: 4 },
                { responsivePriority: 4 }
            ];

            // remove 5th column
            if (this.$hideColumn === 'true') {
                this.responsivePriority.splice(5, 1);
            }

            this.columnDefs = [
                {
                    targets: [-1, -2, -3],
                    className: 'none'
                }
            ];

            this.emptyTableError = this.$el.data('emptyTableError');
            this.stripeClasses = ['odd'];

            //make sure tracking number column has higher priority
            var indexOfTrackingCol = this.$table.find('th.ppt-tracking').index();
            this.responsivePriority[indexOfTrackingCol].responsivePriority = 1;

            ws.views.staticTable.prototype.initialize.call(this);
            this.notes = $('.nonphysicalDataNotes');
        },

        events: _.extend({}, ws.views.staticTable.prototype.events, {
            'click a.openNotes': 'showNote',
            'click .trackingLink': 'handleTrackingLinkClick',
            'click .invoiceLink': 'handleInvoiceLinkClick',
            'click .order-packingSlipLink': 'handlePackingSlipClick',
            'mouseenter .non-physical-order': 'trackingInformationIcon'
        }),

        /**
         * Overriding styleChildTr
         */
        styleChildTr: function(e) {
            const tr = $(e.currentTarget).closest('tr');
            const childTr = $(tr).next();

            if ($(childTr).hasClass('child')) {
                $(childTr).removeClass('parent');
            }

            if ($(childTr).hasClass('child') && ($(tr).hasClass('last-row') || $(tr).hasClass('single-line-status'))) {
                $(childTr).addClass('last-row');
                $(tr).removeClass('last-row');
            } else if (!$(tr).hasClass('last-row') && !$(tr).hasClass('final-row') && !$(tr).hasClass('single-row')) {
                $(tr).addClass('last-row');
            }
        },

        /**
         * Show Data on notes modal
         */
        showNote: function (e) {
            this.notes.html($(e.currentTarget).data('attr'));
        },

        /**
         * Handle tracking link click and trigger analytics event
         *
         * @param {Object} e
         */
        handleTrackingLinkClick (e) {
            e.preventDefault();
            this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_ACTION_CARRIER_TRACKING);
            _satellite.track('event:order:carrierTrackingProofDelivery');
            window.open($(e.currentTarget).attr('data-carrier-url'), '_blank');
        },

        /**
         * Handle invoice link click and trigger analytics event
         *
         */
        handleInvoiceLinkClick () {
            this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_ACTION_INVOICE_LINK);
            _satellite.track('event:order:invoices');
        },

        /**
         * Handle packing slip number click and trigger analytics event
         *
         */
        handlePackingSlipClick () {
            this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_ACTION_PACKING_SLIP, this.GTM_EVENT_ACTION_PACKING_SLIP_LABEL);
            _satellite.track('event:order:viewPackingSlips');
        },

        /**
         * Track information icon event
         */
        trackingInformationIcon () {
            this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_ACTION_INFORMATION_ICON);
        }

    });
}(westcon));
